// extracted by mini-css-extract-plugin
export default {"iframe":"EntriModal_iframe__5ymjs","buttonContainer":"EntriModal_buttonContainer__qvaaP"};